var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"sidebar",attrs:{"mode":"vertical","show-timeout":200,"default-active":_vm.$route.path,"collapse":true}},[_c('sidebar-item',{attrs:{"routes":_vm.routes(_vm.permissionRoutes)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }